import React, { memo, ReactElement, ReactNode } from 'react';
import { ActionCardThemes } from '../../libraries/ActionCardThemes';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './ActionCard.scss';
const rootClassName = 'action-card';

export interface ActionCardProps {
  text: string;
  theme?: ActionCardThemes;
  element?: JSX.Element | ReactElement | ReactNode;
}

function ActionCard(props: ActionCardProps) {
  return (
    <div className={getMergedClassNames([rootClassName, props.theme])}>
      <div className='bar' />
      <div className='text nunito'>{props.text}</div>
      {props.element ? (
        <div className='action'>{props.element}</div>
      ) : undefined}
    </div>
  );
}

ActionCard.defaultProps = {
  theme: ActionCardThemes.Primary,
  text: '',
};

export default memo(ActionCard);
